jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;

	// mobile_detect_enable = true;
	// ismobile_enable = true;
	// isbrowser_enable = true;
  // listen to this variables for results: browserName, isMobile


	mobile_detect_enable = (typeof mobile_detect_enable !== 'undefined')? mobile_detect_enable : true;
	ismobile_enable = (typeof ismobile_enable !== 'undefined')? ismobile_enable : true;
	isbrowser_enable = (typeof isbrowser_enable !== 'undefined')? isbrowser_enable : true;

	let userAgent = navigator.userAgent;
	let browserName;
	let isMobile;

	if(mobile_detect_enable) {
		if(logit) console.log('[MOBILE DETECT] Started. Mobile: '+ismobile_enable +' Browser: '+isbrowser_enable );

		if(ismobile_enable) {
			let isMobile = window.matchMedia("(pointer:coarse)").matches;
			//isMobile = navigator.userAgentData.mobile;

			if(logit == 2) console.log('[MOBILE DETECT] IsMobile: ' + isMobile);
		}

		if(isbrowser_enable) {


			if (userAgent.match(/chrome|chromium|crios/i)) {
	      browserName = "Chrome";
	    } else if (userAgent.match(/firefox|fxios/i)) {
	      browserName = "Firefox";
	    } else if (userAgent.match(/safari/i)) {
	      browserName = "Safari";
	    } else if (userAgent.match(/opr\//i)) {
	      browserName = "Opera";
	    } else if (userAgent.match(/edg/i)) {
	      browserName = "Edge";
	    } else if (userAgent.match(/android/i)) {
	      browserName = "Android";
	    } else if (userAgent.match(/iphone/i)) {
	      browserName = "iPhone";
	    } else {
	      browserName = "Unknown";
	    }

			if(logit == 2) console.log('[MOBILE DETECT] Browser: ' + browserName);


		} else {
			if(logit == 3) console.log('[MOBILE DETECT] Disabled');
		}

	}




	// END JQUERY
});
